import { track } from '@tldraw/tldraw'
import Styles from './ColorsPanel.module.scss'
import { Color, GradientColor, SolidColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { observer } from 'mobx-react-lite'
import { Section } from './Section'
import { Text } from 'blaze-ui/Text/Text'
import { ColorsGrid } from './ColorsGrid'
import { GRADIENTS } from './constants'
import { NewGradientButton } from './NewGradientButton'
import { useState } from 'react'
import { GradientDirectionEditor } from './GradientDirectionEditor'
import { GradientFlipDirectionButton } from './GradientFlipDirectionButton'
import { GradientStopsEditor } from './GradientStopsEditor'

interface Props {
  documentColors: Color[]
  selectedColor: GradientColor
  onSelect: (color: Color) => void
  onNewColorChange: (color: Color) => void
}

export const GradientColorsPanelBody = track(
  observer(({ documentColors, selectedColor, onSelect, onNewColorChange }: Props) => {
    const { isMobile } = useResponsiveDesign()
    const [isCreatingNewGradient, setIsCreatingNewGradient] = useState(false)
    const [isFlipped, setIsFlipped] = useState(false)

    return (
      <div className={Styles.sections}>
        <Section.Root>
          <div className={Styles.gradientEditorSection}>
            <GradientDirectionEditor selectedColor={selectedColor} onNewColorChange={onNewColorChange} />
            <div className={Styles.gradientEditorDivider} />
            <GradientStopsEditor
              key={`${isFlipped}`}
              selectedColor={selectedColor}
              onNewColorChange={onNewColorChange}
              documentSolidColors={documentColors.filter((c) => c.type === 'solidColor') as SolidColor[]}
            />
            <GradientFlipDirectionButton
              selectedColor={selectedColor}
              onNewColorChange={onNewColorChange}
              onFlip={() => setIsFlipped((isFlipped) => !isFlipped)}
            />
          </div>
        </Section.Root>
        <Section.Root>
          <Section.Header>
            <Text variant="smallList">File Gradients</Text>
          </Section.Header>

          <ColorsGrid
            colors={documentColors.filter((c) => c.type === 'linearGradient')}
            selectedColor={selectedColor}
            onSelect={onSelect}
            size={isMobile ? 42 : 30}
          >
            <NewGradientButton
              onChange={onNewColorChange}
              isSelected={isCreatingNewGradient}
              onOpenChange={setIsCreatingNewGradient}
            />
          </ColorsGrid>
        </Section.Root>
        <Section.Root>
          <Section.Header>
            <Text variant="smallList">Presets</Text>
          </Section.Header>

          <ColorsGrid colors={GRADIENTS} selectedColor={selectedColor} onSelect={onSelect} size={isMobile ? 42 : 30}>
            <NewGradientButton
              onChange={onNewColorChange}
              isSelected={isCreatingNewGradient}
              onOpenChange={setIsCreatingNewGradient}
            />
          </ColorsGrid>
        </Section.Root>
      </div>
    )
  }),
)
